import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";
import { PageContainer } from "@/features/ui";

import { useAuth } from "@/features/authentication";
import { PurchaseDownPaymentForm } from "@/features/purchase-down-payments";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { CenteredLoading, useSnackbar } from "@/features/ui";

export const CreatePurchaseDownPayment = () => {
  const { outlet } = useAuth();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      const { buyerId, ...payload } = formData;

      await apiOutletClient.post("purchase-down-payments", payload, {
        headers: {
          "Outlet-Id": buyerId,
        },
      });
      navigate(-1);
    } catch (error) {
      const errorMessage =
        getErrorMessage(error, "Gagal membuat uang muka pembelian");
      showSnackbar(errorMessage);
    }
  };

  if (!outlet) {
    return <CenteredLoading />;
  }

  return (
    <PageContainer
      maxWidth="xl"
      title="Buat Uang Muka Pembelian"
      breadcrumbs={[
        {
          title: "Uang Muka Pembelian",
          path: "/procurement/purchase-down-payments",
        },
        { title: "Buat" },
      ]}
    >
      <PurchaseDownPaymentForm
        onSubmit={handleSubmit}
        defaultValues={{
          buyer: outlet,
        }}
        renderActionButton={({ isSubmitting }) => (
          <Button type="submit" variant="contained" loading={isSubmitting}>
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
